import React from 'react';

interface State {}

const OrdersTaxPage = () => {
  return <>OrdersTaxPage</>;
};

export default OrdersTaxPage;
